import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface TableScrollContainerProps {
  children: ReactNode;
  className?: string;
  minWidth?: string;
}

const TableScrollContainer = ({
  children,
  className,
  minWidth = "600px",
}: TableScrollContainerProps) => {
  return (
    <div className={cn("relative", className)}>
      <div className="overflow-x-auto">
        <div style={{ minWidth }}>{children}</div>
      </div>
      {/* Fade indicator on right edge to hint at scrollable content */}
      <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none md:hidden" />
    </div>
  );
};

export default TableScrollContainer;
